import { Event } from "event-system";
import { Container, IDestroyOptions, Sprite, Texture } from "pixi.js";

export class HiddenInputZone extends Container {
    public readonly onClick: Event<void>;

    private readonly holdTime: number;
    private readonly hiddenInput: Sprite;

    private clicked: boolean;
    private onClickTime: number;

    public constructor(width: number, height: number, holdTime: number = 0) {
        super();
        this.onClick = new Event();
        this.holdTime = holdTime;
        this.clicked = false;
        this.onClickTime = 0;
        this.hiddenInput = new Sprite(Texture.EMPTY);
        this.hiddenInput.width = width;
        this.hiddenInput.height = height;
        this.hiddenInput.alpha = 0;
        this.hiddenInput.interactive = true;
        this.addChild(this.hiddenInput);

        this.hiddenInput.on("pointerdown", this.onPointerDown, this);
        this.hiddenInput.on("pointerup", this.onPointerUp, this);
        this.hiddenInput.on("pointerupoutside", this.onPointerUp, this);
        this.hiddenInput.on("pointerout", this.onPointerUp, this);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.hiddenInput.off("pointerdown", this.onPointerDown, this);
        this.hiddenInput.off("pointerup", this.onPointerUp, this);
        this.hiddenInput.off("pointerupoutside", this.onPointerOut, this);
        this.hiddenInput.off("pointerout", this.onPointerOut, this);
        super.destroy(options);
    }

    private onPointerDown(): void {
        if (this.clicked) {
            return;
        }
        this.clicked = true;
        this.onClickTime = Date.now();
    }

    private onPointerUp(): void {
        if (!this.clicked) {
            return;
        }
        this.clicked = false;
        if (Date.now() - this.onClickTime >= this.holdTime) {
            this.onClick.emit();
        }
        this.onClickTime = 0;
    }

    private onPointerOut(): void {
        if (!this.clicked) {
            return;
        }
        this.clicked = false;
        this.onClickTime = 0;
    }
}